import { Button } from "@mui/material";
import { color } from "echarts";
import React from "react";
import { Modal, ModalBody,ModalFooter,ModalHeader } from "reactstrap";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
function TariffModal(props) {
  return (
    <div>
      <Modal
        isOpen={props.isOpen}
        toggle={props.toggler}
        size={props.size}
        centered
        className="common-modal"
        backdrop="static"
      >
        <ModalHeader toggle={props.toggler} style={{color:"#41CC7D"}}>
            {props.title}
        </ModalHeader>
        
        <ModalBody className={props.bodyClass}
        style={{paddingBottom:"5%",border:0}}
        >{props.children}</ModalBody>
      </Modal>
    </div>
  );
}

export default TariffModal;
